
import { CloseSquare, GalleryAdd } from 'iconsax-react';
import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Link, Typography } from "@mui/material";
import styles from '../my-data.module.scss';

const UploadImgModal = observer(({ uiStore }) => {
    const [widget, setWidget] = useState(undefined);
    const [show, setShow] = useState(false);

    const checkIfAllowedToUpload = async () => {
        return await uiStore.checkImages();
    }

    // Perform the upload
    const handleUpload = async (url, public_id) => {
        await uiStore.uploadImage(url, public_id);
    }

    const showWidget = async () => {
        let allowed = await checkIfAllowedToUpload();

        if (!allowed.allow) {

            setShow(true);

        } else {

            setWidget(window.cloudinary.createUploadWidget({
                cloudName: "dwlzf32s3",
                uploadPreset: "fwyci7lc",
                multiple: false,
                cropping: true,
                showSkipCropButton: true,
                croppingAspectRatio: 1,
                maxFileSize: 3145728,
                stylesheet: "#cloudinary-widget .ReactCrop__crop-selection{border-radius: 100% !important;}",
                styles: {
                    palette: {
                        window: "#ffffff",
                        sourceBg: "#f4f4f5",
                        windowBorder: "#90a0b3",
                        tabIcon: "#000000",
                        inactiveTabIcon: "#555a5f",
                        menuIcons: "#555a5f",
                        link: "#1D1761",
                        action: "#339933",
                        inProgress: "#0433ff",
                        complete: "#339933",
                        error: "#cc0000",
                        textDark: "#000000",
                        textLight: "#fcfffd"
                    },
                    fonts: {
                        default: null,
                        "'Fira Sans', sans-serif": {
                            url: "https://fonts.googleapis.com/css?family=Fira+Sans",
                            active: true
                        }
                    }
                }
            }, (error, result) => {
                if (!error && result && result.event === "success") {
                    handleUpload(result.info.url, result.info.public_id);
                }
            }));
        }
    }

    useEffect(() => {

        if (widget) {
            widget.open();
        }

    }, [widget]);


    return (
        <>
            <Button variant="contained" color='skyBlue' className={styles.addImgBtn} onClick={showWidget}>
                <GalleryAdd
                    size="32"
                    variant="Bulk"
                />
                <Typography sx={{ mt: 1 }} fontWeight={500}>Upload Image</Typography>
            </Button>
            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            >
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <p>You have reach the maximum number of images allowed for this account. More images available when creating a new card.</p>
                    <Link sx={{mr: 2}} className="underline" href='/my-profiles?action=new-card'>Create new card</Link>
                    <Link className="blue-btn" href='/my-data?win=images'>Manage Images</Link>
                </DialogContent>
            </Dialog>
        </>
    );


});

export default UploadImgModal;
